@if (!cacheChamp && !readonly) {
    <fieldset
        class="form-group {{(ctrl && !ctrl.valid && ctrl.errors !== null && files.length===0) ? 'form-error' : ''}}"
    >
        <label class="custom-file center-block block upload-error" [class.disabled]="disabled">
            <input [formControl]="ctrl" [multiple]="(maxFiles !== 1)" type="file"
                   #myFiles (change)="onFileChange($event)"
                   id="fichier" name="fichier"
                   class="form-control custom-file-input"
                   [accept]="acceptedExt"
            />
            <span id="{{idComponent}}" class="custom-file-control" lang="{{translate.currentLang}}"
                  [attr.data-value]="messageChoisirFichier + '...'"></span>
        </label>
        <div class="invalid-feedback fileUploadValidMsg"
             [ngStyle]="{'display': fileUploadValid === false ? 'inline' : 'none'}">
            {{ (errorMessage !== null && errorMessage !== '') ? "* " + errorMessage : '' }}
        </div>
    </fieldset>
}

@if (beforeFilesContainer) {
    <div [innerHTML]="beforeFilesContainer"></div>
}

@if (files !== null && files.length) {
    <div class="files-container">
        <mat-list>
            @for (file of files; track file; let i = $index) {
                @if (file['@id'] !== null) {
                    <mat-list-item lines="4">
                        <div matListItemTitle>
                            <div class="title-file">
                                <input
                                    class="form-control"
                                    placeholder="{{showChangeFileName ? ('front.candidature.titreDocument' | translate) : file.originalFilename}}"
                                    [(ngModel)]="file.label"
                                    [readOnly]="readonly"
                                    [disabled]="!showChangeFileName"
                                    id="label" name="label" type="text" (keyup)="saveLabel(file)">
                            </div>
                            <div class="actions">
                                <button mat-icon-button (click)="download(file)"
                                        matTooltip="{{ 'general.telecharger' | translate }}">
                                    <mat-icon>cloud_download</mat-icon>
                                </button>
                                @if (!readonly) {
                                    <button mat-icon-button
                                            (click)="delete(file,i)"
                                            matTooltip="{{ 'general.supprimer' | translate }}">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                }
                            </div>
                        </div>
                        @if (showChangeFileName) {
                            <div matListItemLine class="filename">
                                {{ file.originalFilename }}
                            </div>
                        }
                    </mat-list-item>
                }
            }
        </mat-list>
    </div>
}

